var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 93 119"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_svg__a",
  d: "M1100.512 193 1054 238.664V312h4.298v-71.589l42.214-41.444 42.19 41.421v67.392h-40.054v-18.909c0-9.568 7.93-17.352 17.676-17.352h.617v4.245l11.213-6.355-11.213-6.356v4.246h-.617c-8.726 0-16.28 5.02-19.825 12.273-3.543-7.252-11.097-12.273-19.823-12.273v-4.246l-11.212 6.356 11.212 6.355v-4.245c9.746 0 17.674 7.784 17.674 17.353V312H1147v-73.36z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_svg__a",
  transform: "translate(-1054 -193)"
})));
export default SvgLogo;